import React from 'react';
import LoanApplicationProfilePreview from '../FormProcess/Forms/loan/LoanApplicationProfilePreview'

const LoanApplication = ({token, from,typeForUser}) => {
    return (
        <div>
           
            <LoanApplicationProfilePreview typeForUser={typeForUser}  applicanttoken={token} from={from} />
            
        </div>
    );
}

export default LoanApplication;
